var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('div',{staticClass:"text-center mt-5"},[_c('h5',{staticClass:"text-center gray",staticStyle:{"line-height":"1.5","margin-top":"6rem"}},[_vm._v("No provider available for this payment option. Kindly use other payment options")])])])
}]

export { render, staticRenderFns }